export const ROUTE_PATH = '/statistics/:entityId';

export const ROUTE_STAT_PATH = `${ROUTE_PATH}/:statId`;
